/*
 * Ryan O'Dowd
 * 2025-05-19
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import NetInfo from '@react-native-community/netinfo';
import fb from '@utils/firebase';
import {
  logout,
} from '@utils/store/actions/common';
import {
  store,
} from '@utils/store';

const _getIdTokenWithRetry = async (retries = 3, delay = 1000) => {
  for (let attemptNum = 1; attemptNum <= retries; attemptNum++) {
    try {
      const jwt = await fb.getIdToken(fb.auth.currentUser);
      if (jwt) {
        return jwt;
      }
      if (attemptNum < retries) {
        await new Promise((res) => setTimeout(res, delay * Math.pow(2, attemptNum)));
      }
    } catch (error) {
      if (error.code === 'auth/network-request-failed' && attemptNum < retries) {
        await new Promise((res) => setTimeout(res, delay * Math.pow(2, attemptNum)));
      } else if (error.code === 'auth/user-token-expired' || error.code === 'auth/no-current-user') {
        // `The user's credential is no longer valid. The user must sign in again.` || `No user currently signed in.`
        // this is almost certainly due to MDL where the user's password was changed on another device; otherwise, this is a weird bug...user needs to log in again (no-current user only ever threw on signOut i think)
        store.dispatch(logout());
        break;
      } else {
        throw error;
      }
    }
  }

  throw new Error('no exception thrown, but no jwt after retries');
};

const getIdTokenSafely = async () => {
  const state = await NetInfo.fetch();
  if (state.isConnected) {
    return await _getIdTokenWithRetry();
  } else {
    throw new Error('No network connection');
  }
};

export default {
  getIdTokenSafely,
};
